import ccdlDatasets from './resources/ccdlDatasets'
import computedFiles from './resources/computedFiles'
import datasets from './resources/datasets'
import projects from './resources/projects'
import samples from './resources/samples'
import tokens from './resources/tokens'
import options from './resources/options'
import stats from './resources/stats'

export const api = {
  ccdlDatasets,
  computedFiles,
  datasets,
  projects,
  samples,
  tokens,
  options,
  stats
}

export default api
